import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, regimen_fiscal } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';
import TipoRegimenjson from '../../../../../Datos/TipoRegimenFiscal.json';

const RegimenFiscal = ({ id, permisos }) => {
    const [ regimenFiscales, setRegimenFiscales ] = useState( null );
    useEffect(() => {
        axiosRegimenFiscales();
    }, []);

    const axiosRegimenFiscales = () => {/*
        axios.get( `${servicios_grupogack_catalogo}/regfiscal/`, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:*/
                        setRegimenFiscales( TipoRegimenjson );
                        /*break;
                    case 404:
                        //setRegimenFiscales([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })*/
    }

    return (
        <div id={ id }>
            { regimenFiscales ?
                <DataTableService id={id} title={ regimen_fiscal } permisos={permisos}
                    columns={[
                        { field: "regFiscalClave", title: "Clave" },
                        { field: "regFiscalDesc", title: "Descripción" },
                    ]}
                    data={ regimenFiscales } /> : <SpinnerOval />
            }
        </div>
    );
};

export default RegimenFiscal;